/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type TermSpanMode = typeof TermSpanMode[keyof typeof TermSpanMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TermSpanMode = {
  IncludeEnds: 'IncludeEnds',
  StartsOnly: 'StartsOnly',
} as const;
